module.exports = __webpack_public_path__ + "img/dai.26d4501f.png";